/**
 * Purpose: Consistent owner-or-superuser checks for edit/delete UI across listing detail pages.
 * Inputs: AuthContext user, resource object or owner id.
 * Outputs: boolean
 */

export function isSuperuser(user) {
  return !!(user && user.is_superuser);
}

export function resolveOwnerId(resource) {
  if (resource == null) return null;
  if (typeof resource !== 'object') return resource;
  if (resource.user_id != null) return resource.user_id;
  const owner = resource.user;
  if (owner == null) return null;
  if (typeof owner === 'object') return owner.id;
  return owner;
}

export function isOwnerOrSuperuser(user, resourceOrOwnerId) {
  if (!user) return false;
  if (isSuperuser(user)) return true;
  const ownerId =
    typeof resourceOrOwnerId === 'object'
      ? resolveOwnerId(resourceOrOwnerId)
      : resourceOrOwnerId;
  if (ownerId == null || user.id == null) return false;
  return String(user.id) === String(ownerId);
}

/** Alias for manage/edit/delete affordances on detail pages. */
export const canManageOwnedResource = isOwnerOrSuperuser;
